module.exports = __webpack_public_path__ + "media/employment.2e50cfbc.png";